import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const usePasswordResetStyles = makeStyles((theme: Theme) => ({
    root: {
        flexGrow: 1
    },
    menuButton: {
        marginRight: theme.spacing(2)
    },
    title: {
        flexGrow: 1
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: '#f50057 !important'
    },
    paper: {
        padding: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    submit: {
        margin: theme.spacing(3, 0, 2)
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        maxWidth: 400,
        marginTop: theme.spacing(3)
    },
    passwordInstructions: {
        paddingTop: theme.spacing(2),
        fontSize: theme.typography.pxToRem(15),
        maxWidth: 550
    }
}));
